import React from "react";
import { connect } from "react-redux";
import { RotaButton } from "@teamrota/rota-design";
import get from "lodash/fp/get";

import FormStepSegment from "../FormStepSegment";
import Textarea from "~/src/components/form-components/textarea";
import Select from "~/src/components/form-components/select";
import { Actions, HeaderTitle, Grow, Header, EditButton } from "../styles";
import {
  useBriefingTemplates,
  useUniformOptions,
  useUpdateBriefing,
  getFormTitle,
  mapStateToProps
} from "./selectors";
import { useValidateRequirements } from "../shared";

const FormRequirements = props => {
  const briefingTemplates = useBriefingTemplates(props) || [];
  const uniformOptions = useUniformOptions(props) || [];
  const onUpdateBriefing = useUpdateBriefing(props);
  const isRequirementsValid = useValidateRequirements(props);

  const selectedBriefing = get("shift.privates.fixedLabel", props);
  const titles = getFormTitle(props);

  return (
    <FormStepSegment
      isOpen={props.isOpen}
      stepNumber={props.stepNumber}
      title={() => (
        <Header>
          {props.hasVisited && !props.isOpen ? (
            <Grow>
              {titles.map((title, index) => (
                <HeaderTitle key={index}>{title}</HeaderTitle>
              ))}
            </Grow>
          ) : (
            <HeaderTitle>Uniform & Briefing</HeaderTitle>
          )}
          {props.hasVisited && !props.isOpen && (
            <EditButton onClick={props.goToSelf}>Edit</EditButton>
          )}
        </Header>
      )}
    >
      {() => (
        <div>
          <Select
            label="Select the Job Uniform"
            shouldFixLabelHeight
            placeholder="Uniform"
            value={props.shift.uniformTemplateId}
            options={uniformOptions}
            onChange={uniformTemplateId => {
              props.handleShiftUpdate({ uniformTemplateId });
            }}
            isSmall
          />

          <Select
            label="Select a Briefing"
            shouldFixLabelHeight
            shouldShowContentAsSelectedLabel
            options={briefingTemplates}
            placeholder="Briefing Templates"
            onChange={onUpdateBriefing}
            value={selectedBriefing}
            isSmall
          />

          <Textarea
            value={props.shift.briefing}
            placeholder="Notes..."
            minRows={4}
            maxRows={4}
            isMultilineAuto
            overrideOrange
            isExtendable
            onChangeValue={briefing => {
              props.handleShiftUpdate({ briefing });
            }}
          />

          <Actions hasTopMargin>
            <RotaButton
              {...(!!isRequirementsValid && {
                onClick: props.goToNext
              })}
              disabled={!isRequirementsValid}
            >
              {props.hasCompletedAllSteps ? "Done" : "Next"}
            </RotaButton>
          </Actions>
        </div>
      )}
    </FormStepSegment>
  );
};

export default connect(mapStateToProps)(FormRequirements);
